<section class="bg-gray-800 pattern py-20 my-4">
    <div class="max-w-5xl px-6 mx-auto text-center">
        <h2 class="text-2xl font-semibold text-white">A propos de moi</h2>

        <p class="text-gray-400 mt-4">{{about}}</p>

    </div>
</section>
